module.exports = __webpack_public_path__ + "static/img/organs.b054609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/organs.jpg
// module id = 0g2n
// module chunks = 1